import moment from "moment";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import message from "../assets/images/message.png";
import { db, firebaseExported } from "../components/Firebase";
import Loader from "../components/Loader";

const ChatPages = () => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loader, setLoader] = useState(false);
  let location = useLocation();
  //console.log("mess", messages);
  useEffect(() => {
    // //console.log("db", firebaseExported.firestore.FieldValue.serverTimestamp);

    const chats = getAllChats();
    // //console.log("first", chats);
  }, [location.state.item.uid]);

  // //console.log(location.state.item.uid);
  const getAllChats = () => {
    // //console.log(location.state.item.firstName);
    db.collection("chatRooms")
      .doc(location.state.item.uid)
      .collection("messages")
      .orderBy("createdAt", "desc")
      .onSnapshot(
        (snapshot) => {
          const messages1 = [];
          snapshot.forEach((message) => {
            messages1.unshift(message.data());
          });
          // //console.log("dsds", messages1);
          setMessages([...messages1]);
          //   setLoader(false);
        },
        (error) => {
          // // //console.log(error);
        }
      );
  };
  const sendMessage = async () => {
    // //console.log("db", firebaseExported.firestore.FieldValue.serverTimestamp());
    const date = new Date();
    const local = date.toLocaleString("en-US");
    setLoader(true);
    if (message) {
      const newMessage = message;
      db.collection("chatRooms")
        .doc(location.state.item.uid)
        .collection("messages")
        .doc()
        .set({
          sentBy: "admin",
          text: newMessage,
          createdAt: new Date(),
          date: local,
        })
        .then(() => {})
        .catch((e) => {
          // // //console.log(e.message);
        });
    }
    setLoader(false);
    setMessage("");
  };
  //   const sendMessage = () => {
  //
  //     setMessages([
  //       ...messages,
  //       {
  //         text: message,
  //         sendbyMe: true,
  //       },
  //     ]);
  //     setMessage("");
  //   };
  // //console.log(messages);
  // //console.log(message);
  // //console.log(location.state.item);
  return (
    <div
      style={{
        height: 90,
      }}
    >
      <div
        style={{
          flex: 1,
        }}
      >
        <div>Chat with {location.state.item.name}</div>
        <div
          style={{
            backgroundColor: "#dcdcdc40",
            height: "55vh",
            overflowY: "scroll",
            borderRadius: 15,
            padding: '30px',
          }}
        >
          {messages.map((i) => {
            //console.log("i", i);
            const picture = i.img;
            const sentBy = i.sentBy === "admin";
            if (loader) {
              <Loader value={loader} />;
            }
            return (
              <div >
              

                <div
                  style={{
                    marginTop: 10,
                    borderRadius: 15,
                    backgroundColor: sentBy ? "pink" : "ButtonShadow",
                    padding: "5px 10px"
                  }}
                >
                  {i.image ? (
                    <img
                      width={180}
                      height={140}
                      style={
                        {
                          // width: 180,
                          // height: 140,
                        }
                      }
                      src={`${i.image}`}
                    />
                  ) : (
                    <p><small>
                  {moment(i.createdAt?.seconds * 1000).format("D MMM, YYYY")}
                  </small><br />
                  {i.text}</p>

                  )}

                  
                </div>
                
              </div>
            );
          })}
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            paddingInline: 20,
            marginTop: 10,
            paddingBottom: 80,
          }}
        >
          <input placeholder="Type here..." class="form-control" value={message} onChange={(e) => setMessage(e.target.value)} />
          <button class="btn btn-primary" onClick={sendMessage}>Send</button>
          
        </div>
      </div>
    </div>
  );
};

export default ChatPages;
